import type { IInspectEnergyAuditNotificationItem } from "@/entities/notification/model/types.ts"
import { FETCH_NOTIFICATIONS_INTERVAL } from "@/shared/constants"
import type { IResponse } from "@/shared/types"
import { requestIntensity } from "@/shared/utils/axios.ts"
import { useQuery } from "@tanstack/react-query"

export async function fetchNotifications(enerdyAuditId: number) {
  const { data } = await requestIntensity(`/energy-audit-notifications/energy-audit/${enerdyAuditId}`)
  return data as IResponse<IInspectEnergyAuditNotificationItem>
}

export async function fetchMyNotifications() {
  const { data } = await requestIntensity(`/energy-audit-notifications/`)
  return data as IResponse<IInspectEnergyAuditNotificationItem>
}

export const useFetchMyNotifications = () => {
  return useQuery({
    queryKey: ["myNotifications"],
    queryFn: () => fetchMyNotifications(),
    refetchInterval: FETCH_NOTIFICATIONS_INTERVAL
  })
}
